<template>
    <div>
        <div class="card">
            <table class="table">
                <thead>
                <tr>
                    <th>No.</th>
                    <th>Customer name</th>
                    <th>Phone number</th>
                    <th>Total Price</th>
                </tr>
                </thead>

                <tbody>
                <tr v-if="loading">
                    <td colspan="4" class="text-center">
                        <b-spinner label="Spinning"></b-spinner>
                    </td>
                </tr>
                <tr v-for="(item, index) in items" :key="index">
                    <td>{{ index + 1 }}</td>
                    <td>{{ item.customer_name }}</td>
                    <td>{{ item.customer_mobile }}</td>
                    <td>{{ item.sum_g | formatNumber }}</td>
                </tr>
                <tr v-if="! loading && items.length === 0">
                    <td colspan="4" class="text-center text-muted"><span>No results</span></td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>


<script>
    export default {

        props: {
            dateRanges: {
                type: Object,
                required: true
            }
        },

        data: () => ({
            loading: false,
            items: [],
        }),

        watch: {
            dateRanges: {
                deep: true,
                handler({fromDate, toDate}) {
                    this.load({fromDate, toDate})
                }
            }
        },

        methods: {
            async load({fromDate, toDate}) {
                this.loading = true

                try {
                    const { data } = await axios.get(`/reports/top-customers`, {
                        params: {
                            from_date: fromDate,
                            to_date: toDate
                        }
                    })

                    this.items = data.data
                } catch (e) {
                    //
                }

                this.loading = false
            }
        },

        mounted() {
            this.load(this.$props.dateRanges)
        }
    }
</script>
